<template>
  <component :is="type" class="a-exhibition-item">
    <h4 class="a-exhibition-item__heading">
      <LinkOrText
        ref="exhibitionTitle"
        :route="to"
        :title="title"
        data-testid="exhibitionTitle"
        class="a-exhibition-item__title"
      />
    </h4>
    <h5 :id="ariaKey" class="visually-hidden">
      {{ locationsAriaHeading }}
    </h5>
    <ul
      class="a-exhibition-item__locations"
      data-testid="exhibitionLocations"
      :aria-labelledby="ariaKey"
    >
      <li
        v-for="location in locations"
        :key="location.name"
        ref="exhibitionLocation"
        class="a-exhibition-item__location"
      >
        <span class="a-exhibition-item__location_name">{{
          location.name
        }}</span>
        <span class="a-exhibition-item__location_timespan">{{
          location.timespan
        }}</span>
      </li>
    </ul>
  </component>
</template>
<script>
import LinkOrText from "@/components/atoms/linkOrText/index.vue";
import { useLocalization } from "@thegetty-private/getty-ui";
import { useId } from "vue";

export default {
  name: "ExhibitionItem",
  components: { LinkOrText },

  props: {
    /**
     * The route to the exhibition page
     */
    to: {
      type: Object,
      required: false,
      default: undefined
    },
    /**
     * The title of the exhibition
     */
    title: {
      type: String,
      required: false,
      default: undefined
    },
    /**
     * the list of locations
     */
    locations: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "li"
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * The ARIA heading for an exhibition's locations list
       */
      locationsAriaHeading: this.translatePart(
        "exhibition_list.locations_aria_heading"
      ),
      ariaKey: `exhibition-locations-aria-${useId()}`
    };
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
